import { render, staticRenderFns } from "./TimeclockCard.template.vue?vue&type=template&id=0dffe97b&scoped=true&"
var script = {}
import style0 from "./TimeclockCard.template.vue?vue&type=style&index=0&id=0dffe97b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dffe97b",
  null
  
)

export default component.exports